export enum AdminBackgroundTaskListItemAction {
  Delete,
}
